<!-- Test change for Netlify deployment -->
<template>
  <div style="background-color: #8fa0a8; min-height: 100vh;">
    <v-container class="pa-4 fill-height">
      <v-row>
        <v-col cols="12" class="d-flex justify-center">
          <h2 class="white--text montserrat-title mb-8">Admin Section</h2>
        </v-col>
      </v-row>
      
      <v-row>
        <!-- User Permissions Card -->
        <v-col cols="12" sm="6" md="4">
          <v-card class="profile-card" elevation="0" @click="openUserPermissions">
            <div class="card-content">
              <div class="icon-container">
                <v-icon class="card-icon" size="36">mdi-account-cog</v-icon>
              </div>
              <h3 class="card-title">User Permissions</h3>
              <p class="card-subtitle">Manage user accounts, roles, and permissions</p>
              <v-btn class="card-button" color="red darken-1" depressed rounded @click.stop="openUserPermissions">
                Manage Permissions
              </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- Add User Card -->
        <v-col cols="12" sm="6" md="4">
          <v-card class="profile-card" elevation="0" @click="dialog = true">
            <div class="card-content">
              <div class="icon-container">
                <v-icon class="card-icon" size="36">mdi-account-plus</v-icon>
              </div>
              <h3 class="card-title">Add User</h3>
              <p class="card-subtitle">Add new users to the system</p>
              <v-btn class="card-button" color="red darken-1" depressed rounded @click.stop="dialog = true">
                Add User
              </v-btn>
            </div>
          </v-card>
        </v-col>


        <!-- Supplier Management Card -->
        <v-col cols="12" sm="6" md="4">
          <v-card class="profile-card" elevation="0" @click="showSupplierComponent = true">
            <div class="card-content">
              <div class="icon-container">
                <v-icon class="card-icon" size="36">mdi-truck</v-icon>
              </div>
              <h3 class="card-title">Supplier</h3>
              <p class="card-subtitle">Manage suppliers</p>
              <v-btn class="card-button" color="red darken-1" depressed rounded @click.stop="showSupplierComponent = true">
                Manage Suppliers
              </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- Company/Customer Management Card -->
        <v-col cols="12" sm="6" md="4">
          <v-card class="profile-card" elevation="0" @click="showCompanyComponent = true">
            <div class="card-content">
              <div class="icon-container">
                <v-icon class="card-icon" size="36">mdi-office-building</v-icon>
              </div>
              <h3 class="card-title">Customer</h3>
              <p class="card-subtitle">Manage customers</p>
              <v-btn class="card-button" color="red darken-1" depressed rounded @click.stop="showCompanyComponent = true">
                Manage Customers
              </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- User Requests Leave Card -->
        <v-col cols="12" sm="6" md="4">
          <v-card class="profile-card" elevation="0" @click="dialogLeaves = true">
            <div class="card-content">
              <div class="icon-container">
                <v-icon class="card-icon" size="36">mdi-calendar-check</v-icon>
              </div>
              <h3 class="card-title">User Requests Leave</h3>
              <p class="card-subtitle">Manage leave requests and approvals</p>
              <v-btn class="card-button" color="red darken-1" depressed rounded @click.stop="dialogLeaves = true">
                Manage Leaves
              </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- User Feedback Card -->
        <v-col cols="12" sm="6" md="4">
          <v-card class="profile-card" elevation="0" @click="dialogFeedback = true">
            <div class="card-content">
              <div class="icon-container">
                <v-icon class="card-icon" size="36">mdi-message-alert-outline</v-icon>
              </div>
              <h3 class="card-title">User Feedback</h3>
              <p class="card-subtitle">Review and respond to user feedback</p>
              <v-btn class="card-button" color="red darken-1" depressed rounded @click.stop="dialogFeedback = true">
                View Feedback
              </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- Set Rate Card -->
        <v-col cols="12" sm="6" md="4">
          <v-card class="profile-card" elevation="0" @click="dialogRate = true">
            <div class="card-content">
              <div class="icon-container">
                <v-icon class="card-icon" size="36">mdi-currency-usd</v-icon>
              </div>
              <h3 class="card-title">Set Rate</h3>
              <p class="card-subtitle">Update the current rate</p>
              <v-btn class="card-button" color="red darken-1" depressed rounded @click.stop="dialogRate = true">
                Update Rate
              </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- NEW: Security Dashboard Card -->
        <v-col cols="12" sm="6" md="4">
          <v-card class="profile-card" elevation="0" @click="$router.push('/admin/security')">
            <div class="card-content">
              <div class="icon-container">
                <v-icon class="card-icon" size="36">mdi-shield-check</v-icon>
              </div>
              <h3 class="card-title">Security Dashboard</h3>
              <p class="card-subtitle">Monitor sessions, login attempts, and security events</p>
              <v-btn class="card-button" color="red darken-1" depressed rounded @click.stop="$router.push('/admin/security')">
                View Dashboard
              </v-btn>
            </div>
          </v-card>
        </v-col>

             <!-- Dropdown Manager Card -->
            <v-col cols="12" sm="6" md="4">
            <v-card class="profile-card" elevation="0" @click="$router.push('/dropdown-manager')">
            <div class="card-content">
            <div class="icon-container">
            <v-icon class="card-icon" size="36">mdi-format-list-bulleted</v-icon>
           </div>
            <h3 class="card-title">Dropdown Manager</h3>
             <p class="card-subtitle">Manage engineers, technicians, and salespersons</p>
            <v-btn class="card-button" color="red darken-1" depressed rounded @click.stop="$router.push('/dropdown-manager')">
        Manage Dropdowns
       </v-btn>
       </div>
       </v-card>
      </v-col>
      </v-row>
    </v-container>



    <!-- User Permission Component (User Management Dialog) -->
    <UserPermission v-model="dialogUserManagement" @alert="showAlert" />

    <!-- Add User Dialog -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card class="rounded-card">
        <v-card-title class="red--text">Add New User</v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field v-model="fullName" label="Full Name" outlined dense rounded required></v-text-field>
            <v-text-field v-model="email" label="Email" outlined dense rounded required></v-text-field>
            <v-text-field v-model="password" label="Password" outlined dense rounded type="password" required></v-text-field>
            <v-text-field v-model="confirmPassword" label="Confirm Password" outlined dense rounded type="password" required></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" @click="submit">Add User</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Users Dialog -->
    <v-dialog v-model="dialogEditUsers" max-width="1200px" scrollable :retain-focus="false">
      <v-card class="rounded-card">
        <v-card-title class="red--text">Edit Users</v-card-title>
        <v-card-text>
          <v-text-field 
            v-model="searchUsers" 
            append-icon="mdi-magnify" 
            label="Search users" 
            single-line 
            hide-details
            class="mb-4"
          ></v-text-field>
          <v-data-table
            :headers="userHeaders"
            :items="filteredUsers"
            :items-per-page-options="[10, -1]"
            :items-per-page="10"
            class="elevation-1 user-table"
            :search="searchUsers"
            :footer-props="{
              'items-per-page-text': 'Rows per page:',
              'items-per-page-options': [
                { text: '10', value: 10 },
                { text: 'All', value: -1 }
              ]
            }"
          >
            <template v-slot:item.actions="{ item }">
              <div class="action-buttons">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                      icon 
                      color="blue" 
                      @click="confirmEditUser(item)" 
                      v-bind="attrs" 
                      v-on="on"
                      class="ma-1"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit User</span>
                </v-tooltip>
                
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      :color="item.disabled ? 'orange' : 'green'"
                      @click="confirmToggleUserStatus(item)"
                      v-bind="attrs"
                      v-on="on"
                      class="ma-1"
                    >
                      <v-icon>{{ item.disabled ? 'mdi-account-off' : 'mdi-account-check' }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.disabled ? 'Enable User' : 'Disable User' }}</span>
                </v-tooltip>
                
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                      icon 
                      color="red" 
                      @click="confirmDeleteUser(item)" 
                      v-bind="attrs" 
                      v-on="on"
                      class="ma-1"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete User</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialogEditUsers = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmation Dialog for Edit -->
    <v-dialog v-model="confirmEditDialog" max-width="400px" :retain-focus="false">
      <v-card>
        <v-card-title class="red--text">Confirm Edit</v-card-title>
        <v-card-text>
          Are you sure you want to edit the user "{{ (confirmUser && confirmUser.fullName) ? confirmUser.fullName : 'Unknown User' }}"?
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="confirmEditDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" @click="openEditUserDialog">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmation Dialog for Disable/Enable -->
    <v-dialog v-model="confirmToggleDialog" max-width="400px">
      <v-card>
        <v-card-title class="red--text">{{ confirmUser?.disabled ? 'Confirm Enable' : 'Confirm Disable' }}</v-card-title>
        <v-card-text>
          Are you sure you want to {{ confirmUser?.disabled ? 'enable' : 'disable' }} the user "{{ (confirmUser && confirmUser.fullName) ? confirmUser.fullName : 'Unknown User' }}"?
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="confirmToggleDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" @click="toggleUserStatus">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmation Dialog for Delete -->
    <v-dialog v-model="confirmDeleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="red--text">Confirm Delete</v-card-title>
        <v-card-text>
         Are you sure you want to delete the user "{{ (confirmUser && confirmUser.fullName) ? confirmUser.fullName : 'Unknown User' }}"? This action cannot be undone.
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="confirmDeleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" @click="deleteUser">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- User Feedback Dialog -->
    <v-dialog v-model="dialogFeedback" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="red">
          <v-btn icon dark @click="dialogFeedback = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>User Feedback</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search feedback" single-line hide-details></v-text-field>
          <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filterDate"
                label="Filter date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="filterDate" no-title scrollable @input="menu = false">
              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(filterDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-toolbar>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4" v-for="feedback in filteredFeedback" :key="feedback.id">
              <v-card>
                <v-carousel height="280px" v-if="feedback.photos && feedback.photos.length">
                  <v-carousel-item v-for="(photo, index) in feedback.photos" :key="index">
                    <v-img :src="photo"></v-img>
                  </v-carousel-item>
                </v-carousel>
                <v-card-title>{{ feedback.fullName }}</v-card-title>
                <v-card-subtitle>{{ new Date(feedback.createdAt).toLocaleDateString() }}</v-card-subtitle>
                <v-card-text>{{ feedback.description }}</v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Manage Leave Requests Dialog -->
    <v-dialog v-model="dialogLeaves" max-width="800px">
      <v-card>
        <v-card-title class="red--text">Manage Leave Requests</v-card-title>
        <v-card-text>
          <v-list dense>
            <v-list-item v-for="request in leaveRequests" :key="request.id" class="leave-request-item">
              <v-list-item-content>
                <v-list-item-title>
                  <v-row>
                    <v-col cols="6">
                      <strong>Full Name:</strong> {{ request.fullName }}
                    </v-col>
                    <v-col cols="6">
                      <strong>Email:</strong> {{ request.email }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <strong>Cellphone:</strong> {{ request.cellphone }}
                    </v-col>
                    <v-col cols="6">
                      <strong>Leave Type:</strong> {{ request.leaveType }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <strong>Start Date:</strong> {{ request.startDate }}
                    </v-col>
                    <v-col cols="6">
                      <strong>End Date:</strong> {{ request.endDate }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <strong>Reason:</strong> {{ request.reason }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <strong>Status:</strong>
                      <v-chip :color="getStatusColor(request.status)" text-color="white">
                        {{ request.status }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon @click="approveRequest(request.id)" color="green">
                  <v-icon>mdi-check</v-icon>
                </v-btn>
                <v-btn icon @click="declineRequest(request.id)" color="red">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialogLeaves = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Single User Dialog -->
    <v-dialog v-model="dialogEditUser" max-width="500px">
      <v-card class="rounded-card">
        <v-card-title class="red--text">Edit User</v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field v-model="editUser.fullName" label="Full Name" outlined dense rounded required></v-text-field>
            <v-text-field v-model="editUser.email" label="Email" outlined dense rounded disabled></v-text-field>
            <v-select
              v-model="editUser.role"
              :items="roles"
              label="Role"
              outlined
              dense
              rounded
              clearable
              placeholder="Select a role"
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialogEditUser = false">Cancel</v-btn>
          <v-btn color="red darken-1" @click="saveEditedUser">Save Changes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Set Rate Dialog -->
    <v-dialog v-model="dialogRate" max-width="600px">
      <v-card>
        <v-card-title class="red--text">Set Rate</v-card-title>
        <v-card-text>
          <div>
            <strong>Current Rate: </strong> {{ currentRate }}
          </div>
          <v-form ref="rateForm">
            <v-text-field
              v-model="rate"
              label="New Rate"
              outlined
              dense
              rounded
              prepend-inner-icon="mdi-currency-usd"
              required
              type="number"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialogRate = false">Cancel</v-btn>
          <v-btn color="red darken-1" @click="saveRate">Save</v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text>
          <h3 class="red--text">Rate History</h3>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Date</th>
                  <th class="text-left">Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="history in rateHistory" :key="history.id">
                  <td>{{ history.updatedAt.toLocaleDateString() }}</td>
                  <td>{{ history.rate }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>

   

    <!-- Supplier Management Component -->
    <SupplierManagement v-if="showSupplierComponent" @close="showSupplierComponent = false" />

    <!-- Customer Management Component -->
    <CompanyManagement v-if="showCompanyComponent" @close="showCompanyComponent = false" />

    <!-- Alert Snackbar -->
    <v-snackbar v-model="alert.visible" :color="alert.type === 'success' ? 'green' : 'red'" top right>
      {{ alert.message }}
      <v-btn text @click="alert.visible = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import UserPermission from '@/components/UserPermission.vue';
import SupplierManagement from '@/components/SupplierManagement.vue';
import CompanyManagement from '@/components/CompanyManagement.vue';
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  getDoc,
  updateDoc,
  setDoc,
  addDoc,
  deleteDoc,
} from 'firebase/firestore';
import { firebaseApp, connectionHandler } from '@/firebaseConfig';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import OldJobs from '../OldJobs/OldJobs.vue';

export default {
  components: {
    UserPermission,
    SupplierManagement,
    CompanyManagement,
  },
  data() {
    return {
      // Dialogs
      dialog: false,
      dialogLeaves: false,
      dialogFeedback: false,
      dialogRate: false,
      dialogUserManagement: false,
      dialogEditUsers: false,
      dialogEditUser: false,
      confirmEditDialog: false,
      confirmToggleDialog: false,
      confirmDeleteDialog: false,

      // Data
      feedbacks: [],
      leaveRequests: [],
      users: [],
      fullName: '',
      role: '',
      roles: ['Engineer', 'Technician', 'Salesperson', 'Manager', 'Debtors', 'Dispatch', 'Stores', 'Procurement'],
      email: '',
      password: '',
      confirmPassword: '',
      search: '',
      searchUsers: '',
      filterDate: '',
      menu: false,
      rate: 0,
      currentRate: 0,
      rateHistory: [],
      editUser: {
        userID: '',
        fullName: '',
        email: '',
        role: '',
      },
      confirmUser: null,
      userHeaders: [
        { text: 'Full Name', value: 'fullName' },
        { text: 'Email', value: 'email' },
        { text: 'Role', value: 'role' },
        { text: 'Status', value: 'status', filterable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],

      // Alerts
      alert: {
        visible: false,
        message: '',
        type: 'success',
      },

      // Control component visibility
      showSupplierComponent: false,
      showCompanyComponent: false,
    };
  },
  computed: {
filteredFeedback() {
  return this.feedbacks.filter((feedback) => {
    const searchLower = this.search.toLowerCase();
    const matchesSearch =
      (feedback.description || '').toLowerCase().includes(searchLower) ||
      (feedback.fullName || '').toLowerCase().includes(searchLower);
    const matchesDate = this.filterDate
      ? new Date(feedback.createdAt).toDateString() === new Date(this.filterDate).toDateString()
      : true;
    return matchesSearch && matchesDate;
  });
},
filteredUsers() {
  // Sort users alphabetically by fullName, then map to add status field
  const sorted = [...this.users].sort((a, b) => {
    const nameA = a.fullName || '';
    const nameB = b.fullName || '';
    return nameA.localeCompare(nameB);
  });
  return sorted.map(user => ({
    ...user,
    status: user.disabled ? 'Disabled' : 'Enabled',
  }));
},
  },
  methods: {
    openUserPermissions() {
      this.dialogUserManagement = true;
    },
    showAlert({ message, type }) {
      this.alert.message = message;
      this.alert.type = type;
      this.alert.visible = true;
    },
    async fetchFeedback() {
      try {
        const result = await connectionHandler.retryOperation(async () => {
          const db = getFirestore(firebaseApp);
          const feedbackQuery = collection(db, 'bugReports');
          return await getDocs(feedbackQuery);
        });
        
        this.feedbacks = result.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          createdAt: doc.data().createdAt.toDate(),
        }));
      } catch (error) {
        console.error('Error fetching feedback:', error);
        this.showAlert({ message: `Error fetching feedback: ${error.message}`, type: 'error' });
      }
    },
    async fetchLeaveRequests() {
      try {
        const result = await connectionHandler.retryOperation(async () => {
          const db = getFirestore(firebaseApp);
          return await getDocs(collection(db, 'Request Leave'));
        });
        
        this.leaveRequests = result.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      } catch (error) {
        console.error('Error fetching leave requests:', error);
        this.showAlert({ message: `Error fetching leave requests: ${error.message}`, type: 'error' });
      }
    },
    async fetchUsers() {
      try {
        const result = await connectionHandler.retryOperation(async () => {
          const db = getFirestore(firebaseApp);
          return await getDocs(collection(db, 'users'));
        });
        
        this.users = result.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      } catch (error) {
        console.error('Error fetching users:', error);
        this.showAlert({ message: `Error fetching users: ${error.message}`, type: 'error' });
      }
    },
    async fetchCurrentRate() {
      try {
        const result = await connectionHandler.retryOperation(async () => {
          const db = getFirestore(firebaseApp);
          const rateDocRef = doc(db, 'rate', 'currentRate');
          return await getDoc(rateDocRef);
        });
        
        if (result.exists()) {
          this.currentRate = result.data().rate;
        }
      } catch (error) {
        console.error('Error fetching current rate:', error);
        this.showAlert({ message: `Error fetching current rate: ${error.message}`, type: 'error' });
      }
    },
    async fetchRateHistory() {
      try {
        const result = await connectionHandler.retryOperation(async () => {
          const db = getFirestore(firebaseApp);
          const rateHistoryQuery = collection(db, 'rateHistory');
          return await getDocs(rateHistoryQuery);
        });
        
        this.rateHistory = result.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          updatedAt: doc.data().updatedAt.toDate(),
        }));
        this.rateHistory.sort((a, b) => b.updatedAt - a.updatedAt);
      } catch (error) {
        console.error('Error fetching rate history:', error);
        this.showAlert({ message: `Error fetching rate history: ${error.message}`, type: 'error' });
      }
    },
    getStatusColor(status) {
      switch (status.toLowerCase()) {
        case 'approved':
          return 'green';
        case 'declined':
          return 'red';
        case 'pending':
          return 'orange';
        default:
          return 'gray';
      }
    },
    async approveRequest(requestId) {
      try {
        await connectionHandler.retryOperation(async () => {
          const db = getFirestore(firebaseApp);
          return await updateDoc(doc(db, 'Request Leave', requestId), {
            status: 'approved',
          });
        });
        
        this.showAlert({ message: 'Request approved successfully!', type: 'success' });
        this.fetchLeaveRequests();
      } catch (error) {
        console.error('Error approving request:', error);
        this.showAlert({ message: `Error approving request: ${error.message}`, type: 'error' });
      }
    },
    async declineRequest(requestId) {
      try {
        await connectionHandler.retryOperation(async () => {
          const db = getFirestore(firebaseApp);
          return await updateDoc(doc(db, 'Request Leave', requestId), {
            status: 'declined',
          });
        });
        
        this.showAlert({ message: 'Request declined successfully!', type: 'success' });
        this.fetchLeaveRequests();
      } catch (error) {
        console.error('Error declining request:', error);
        this.showAlert({ message: `Error declining request: ${error.message}`, type: 'error' });
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\.,;:\s@"]+(\.[^<>()\[\]\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\.,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,})$/i;
      return re.test(String(email).toLowerCase());
    },
    validatePassword(password) {
      const re = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9])(?=.*[a-z]).{6,}$/;
      return re.test(password);
    },
    async submit() {
      if (this.password !== this.confirmPassword) {
        this.showAlert({ message: 'Passwords do not match!', type: 'error' });
        return;
      }
      if (!this.validateEmail(this.email)) {
        this.showAlert({ message: 'Invalid email address!', type: 'error' });
        return;
      }
      if (!this.validatePassword(this.password)) {
        this.showAlert({
          message:
            'Password must be greater than 6 characters, contain at least one capital letter and one special character!',
          type: 'error',
        });
        return;
      }
      
      try {
        const result = await connectionHandler.retryOperation(async () => {
          const auth = getAuth(firebaseApp);
          const db = getFirestore(firebaseApp);
          
          const userCredential = await createUserWithEmailAndPassword(auth, this.email, this.password);
          const user = userCredential.user;
          
          const defaultPermissions = {
            OldJobs: {
              View_in_Functions: false,
              View_in_Activities: false,
              Add_Button: false,
              Edit_Details: false,
              View_Line_Items_Labour_and_Stock: false,
              View_Supplier_Info: false,
              Override_All: false,
            },
            jobReports: {
              View_in_Functions: false,
              View_in_Activities: false,
              Add_Button: false,
              Edit_Details: false,
              Override_All: false,
            },
            deliveries: {
              View_In_Function: false,
              View_in_Activity: false,
              Add_Delivery: false,
              Edit_Delivery_Card_Details: false,
              Edit_Delivery_Items: false,
              Override: false,
            },
            returns: {
              View_in_Functions: false,
              View_in_Activities: false,
              Add_Button: false,
              Edit_Details: false,
              View_Line_Items_Labour_and_Stock: false,
              View_Supplier_Info: false,
              Override_All: false,
              Placeholder_for_8th_Column: false,
            },
            purchaseOrders: {
              View_in_Functions: false,
              View_in_Activities: false,
              Add_Button: false,
              Edit_Details: false,
              View_Line_Items_Labour_and_Stock: false,
              View_Supplier_Info: false,
              Override_All: false,
              Placeholder_for_8th_Column: false,
            },
            engineerQuotes: {
              View_in_Functions: false,
              View_in_Activities: false,
              Add_Button: false,
              Edit_Details: false,
              View_Line_Items_Labour_and_Stock: false,
              View_Supplier_Info: false,
              Override_All: false,
            },
            salesOrderTracker: {
              View_in_Functions: false,
              View_in_Activity: false,
              Add_Button: false,
              Edit_Details: false,
              Override_All: false,
            },
            awaitingSpares: {
              View_in_Functions: false,
              View_in_Activities: false,
              Add_Button: false,
              Edit_Details: false,
              Override_All: false,
            },
            samples: {
              View_in_Functions: false,
              View_in_Activities: false,
              Add_Button: false,
              Edit_Details: false,
              Override_All: false,
            },
            shipment: {
              View_in_Functions: false,
              View_in_Activities: false,
              Add_Button: false,
              Edit_Details: false,
              Override_All: false,
            },
            serial: {
              View_in_Functions: false,
              View_in_Activities: false,
              Add_Button: false,
              Edit_Details: false,
              Override_All: false,
            },
            customerQuotes: {
            View_in_Functions: false,
            View_in_Activities: false,
            Add_Button: false,
            Edit_Details: false,
            Override_All: false,
            },
            quoted: {
            View_in_Functions: false,
            View_in_Activities: false,
            Edit_Details: false,
            Override_All: false,
            },
            inventoryView: {
              View_in_Functions: false,
              View_Inventory_Cost: false,
            },
            permissions: {
              functions: false,
              jobs: false,
              purchaseOrder: false,
              returns: false,
            },
          };

          return await setDoc(doc(db, 'users', user.uid), {
            userID: user.uid,
            fullName: this.fullName,
            role: this.role || '',
            email: this.email,
            createdAt: new Date(),
            disabled: false,
            ...defaultPermissions,
          });
        });
        
        this.showAlert({ message: 'User registered successfully!', type: 'success' });
        this.dialog = false;
        this.clearForm();
        this.fetchUsers();
      } catch (error) {
        console.error('Error creating user:', error);
        this.showAlert({ message: `Error creating user: ${error.message}`, type: 'error' });
      }
    },
    clearForm() {
      this.fullName = '';
      this.role = '';
      this.email = '';
      this.password = '';
      this.confirmPassword = '';
    },
    async saveRate() {
      if (!this.rate) {
        this.showAlert({ message: 'Please enter a valid rate!', type: 'error' });
        return;
      }
      
      try {
        await connectionHandler.retryOperation(async () => {
          const db = getFirestore(firebaseApp);
          
          await updateDoc(doc(db, 'rate', 'currentRate'), {
            rate: this.rate.toString(),
            updatedAt: new Date(),
          });
          
          return await addDoc(collection(db, 'rateHistory'), {
            rate: this.rate.toString(),
            updatedAt: new Date(),
          });
        });
        
        this.showAlert({ message: 'Rate updated successfully!', type: 'success' });
        this.dialogRate = false;
        this.fetchCurrentRate();
        this.fetchRateHistory();
      } catch (error) {
        console.error('Error saving rate:', error);
        this.showAlert({ message: `Error saving rate: ${error.message}`, type: 'error' });
      }
    },
    confirmEditUser(user) {
      this.confirmUser = user;
      this.confirmEditDialog = true;
    },
    confirmToggleUserStatus(user) {
      this.confirmUser = user;
      this.confirmToggleDialog = true;
    },
    confirmDeleteUser(user) {
      this.confirmUser = user;
      this.confirmDeleteDialog = true;
    },
    openEditUserDialog() {
      if (!this.confirmUser) return;
      this.editUser = {
        userID: this.confirmUser.userID,
        fullName: this.confirmUser.fullName,
        email: this.confirmUser.email,
        role: this.confirmUser.role,
      };
      this.dialogEditUser = true;
      this.confirmEditDialog = false;
      this.confirmUser = null;
    },
    async saveEditedUser() {
      if (!this.editUser.fullName) {
        this.showAlert({ message: 'Full name is required!', type: 'error' });
        return;
      }
      
      try {
        await connectionHandler.retryOperation(async () => {
          const db = getFirestore(firebaseApp);
          return await updateDoc(doc(db, 'users', this.editUser.userID), {
            fullName: this.editUser.fullName,
            role: this.editUser.role || '',
          });
        });
        
        this.showAlert({ message: 'User updated successfully!', type: 'success' });
        this.dialogEditUser = false;
        this.fetchUsers();
      } catch (error) {
        console.error('Error updating user:', error);
        this.showAlert({ message: `Error updating user: ${error.message}`, type: 'error' });
      }
    },
    async toggleUserStatus() {
      if (!this.confirmUser) return;
      const newStatus = !this.confirmUser.disabled;
      
      try {
        await connectionHandler.retryOperation(async () => {
          const db = getFirestore(firebaseApp);
          return await updateDoc(doc(db, 'users', this.confirmUser.userID), {
            disabled: newStatus,
          });
        });
        
        this.showAlert({
          message: `User ${newStatus ? 'disabled' : 'enabled'} successfully!`,
          type: 'success',
        });
        this.confirmToggleDialog = false;
        this.confirmUser = null;
        this.fetchUsers();
      } catch (error) {
        console.error('Error toggling user status:', error);
        this.showAlert({ message: `Error toggling user status: ${error.message}`, type: 'error' });
      }
    },
    async deleteUser() {
      if (!this.confirmUser) return;
      
      try {
        await connectionHandler.retryOperation(async () => {
          const db = getFirestore(firebaseApp);
          return await deleteDoc(doc(db, 'users', this.confirmUser.userID));
        });
        
        this.showAlert({ message: 'User deleted successfully!', type: 'success' });
        this.confirmDeleteDialog = false;
        this.confirmUser = null;
        this.fetchUsers();
      } catch (error) {
        console.error('Error deleting user:', error);
        this.showAlert({ message: `Error deleting user: ${error.message}`, type: 'error' });
      }
    },
  },
  mounted() {
    this.fetchFeedback();
    this.fetchLeaveRequests();
    this.fetchCurrentRate();
    this.fetchRateHistory();
    this.fetchUsers();
  },
  watch: {
    dialogLeaves(val) {
      if (val) {
        this.fetchLeaveRequests();
      }
    },
    dialogEditUsers(val) {
      if (val) {
        this.fetchUsers();
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');

body,
div,
span,
h2,
h3,
p {
  font-family: 'Montserrat', sans-serif;
}

.montserrat-title {
  font-weight: 700;
  font-size: 2.5rem;
}

/* Profile-style cards */
.profile-card {
  background: white;
  border-radius: 20px;
  padding: 0;
  height: 240px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.profile-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.card-content {
  padding: 24px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-between;
}

.icon-container {
  margin-bottom: 12px;
}

.card-icon {
  color: #757575;
  margin-bottom: 8px;
}

.card-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  line-height: 1.3;
}

.card-subtitle {
  font-size: 0.85rem;
  color: #6c757d;
  margin-bottom: 16px;
  line-height: 1.4;
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.card-button {
  width: 100%;
  height: 36px;
  font-weight: 600;
  text-transform: none;
  font-size: 0.9rem;
  border-radius: 12px;
  color: white !important;
}

/* Other existing styles */
.leave-request-item {
  margin-bottom: 16px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background-color: #f7f7f7;
}

.leave-request-item:hover {
  background-color: #f1f1f1;
}

.rounded-card {
  border-radius: 16px;
}

.v-dialog__content {
  padding: 20px;
  border-radius: 16px;
}

.v-data-table {
  background-color: #ffffff;
}

.v-data-table-header {
  background-color: #ff1744;
  color: white;
}

.v-data-table-header th {
  font-weight: bold;
}

.v-data-table__actions {
  display: flex;
  gap: 8px;
}

.user-table {
  background-color: #ffffff;
}

.user-table .v-data-table__wrapper {
  max-height: 60vh;
  overflow-y: auto;
}

.action-buttons {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 140px;
  flex-wrap: nowrap;
}

.action-buttons .v-btn {
  min-width: 36px !important;
  width: 36px;
  height: 36px;
}

.v-data-table td {
  padding: 8px 16px !important;
  white-space: nowrap;
}

.v-data-table th {
  padding: 8px 16px !important;
}

@media (max-width: 1200px) {
  .user-table .v-data-table__wrapper {
    overflow-x: auto;
  }
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .card-content {
    padding: 30px 20px;
  }
  
  .card-title {
    font-size: 1.3rem;
  }
  
  .profile-card {
    height: 280px;
  }
}

@media (max-width: 600px) {
  .montserrat-title {
    font-size: 2rem;
  }
  
  .profile-card {
    height: 260px;
  }
  
  .card-content {
    padding: 25px 15px;
  }
}
</style>